import { useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import styles from "./Login.module.less";
import { loginRequest } from "../../../authConfig";
import { setOauthAzure } from "../../../redux/slices/backend/oauth";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = (loginType: string) => {
    if (loginType === "popup") {
      const accountInfo = instance
        .loginRedirect(loginRequest)
        .then((response) => {
          window.sessionStorage.setItem(
            "accountInfo",
            JSON.stringify(response)
          );
        })
        .catch((error) => {
          console.error("accountInfo error", { error });
        });

      setOauthAzure(instance.loginRedirect(loginRequest));
      setOauthAzure(accountInfo);
    } else if (loginType === "redirect") {
      const accountInfo = instance
        .loginRedirect(loginRequest)
        .then((response) => {
          window.sessionStorage.setItem(
            "accountInfo",
            JSON.stringify(response)
          );
        })
        .catch((error) => {
          console.error("accountInfo error", { error });
        });

      setOauthAzure(instance.loginRedirect(loginRequest));
      setOauthAzure(accountInfo);
    }
  };
  return (
    <div className={styles.form}>
      <Button
        className={styles.wrapperButton}
        onClick={() => handleLogin("redirect")}
        key="loginRedirect"
      >
        Login Azure
      </Button>
    </div>
  );
};
